// extracted by mini-css-extract-plugin
export var closeBtnContainer = "styleModal-module--closeBtnContainer--cbe00";
export var popBox = "styleModal-module--popBox--e813f";
export var popBox_base = "styleModal-module--popBox_base--a146e";
export var popBox_overlay = "styleModal-module--popBox_overlay--aa429";